"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectGroup = exports.Option = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FieldLayout = require("./layout/FieldLayout");

var _FieldLabel = require("./microFields/FieldLabel");

var _FieldSelect = require("./microFields/FieldSelect");

var _FieldValidationMessage = require("./microFields/FieldValidationMessage");

var _FieldIconsDisplay = require("./microFields/FieldIconsDisplay");

var _fieldUtils = require("./microFields/fieldUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(_ref) {
  var label = _ref.label,
      value = _ref.value;

  if (value === null) {
    // A `null` value indicates that the option should not be selectable
    return _react.default.createElement("optgroup", {
      label: label
    });
  }

  return _react.default.createElement("option", {
    value: value
  }, label);
};

exports.Option = Option;
Option.defaultProps = {
  value: null
};
Option.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  label: _propTypes.default.string.isRequired
};

var SelectGroup = function SelectGroup(_ref2) {
  var fieldName = _ref2.fieldName,
      value = _ref2.value,
      atts = _ref2.atts,
      cashbotName = _ref2.cashbotName,
      doFocus = _ref2.doFocus,
      isRequiredField = _ref2.isRequiredField,
      label = _ref2.label,
      options = _ref2.options,
      showUntouchedErrors = _ref2.showUntouchedErrors,
      transparent = _ref2.transparent,
      isCentered = _ref2.isCentered,
      hiddenLabel = _ref2.hiddenLabel,
      hideValidationIcon = _ref2.hideValidationIcon,
      isInvalid = _ref2.isInvalid,
      isTouched = _ref2.isTouched,
      errorMessage = _ref2.errorMessage,
      warningMessage = _ref2.warningMessage;
  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(fieldName);
  var validationProps = (0, _fieldUtils.getValidationProps)(value, isInvalid, isTouched, warningMessage, errorMessage, false, showUntouchedErrors);
  var showInvalid = validationProps.isInvalid;
  var defaultOptions = options.map(function (option) {
    return _react.default.createElement(Option, {
      label: option.label,
      value: option.value,
      key: "".concat(option.value, "-").concat(option.label)
    });
  });
  var selectProps = {
    name: fieldName,
    label: label,
    atts: atts,
    isInvalid: showInvalid,
    isRequiredField: isRequiredField,
    doFocus: doFocus,
    isCentered: isCentered,
    transparent: transparent,
    hiddenLabel: hiddenLabel
  };
  var selectArrowProps = {
    isInvalid: showInvalid,
    hasTransparentBackground: transparent
  };
  var labelProps = {
    fieldName: fieldName,
    label: label,
    isInvalid: showInvalid,
    isHidden: hiddenLabel
  };
  var validationMsgProps = {
    id: fieldIds.validation.id,
    fieldName: fieldName,
    hideValidationIcon: hideValidationIcon,
    validationProps: validationProps
  };
  return _react.default.createElement(_FieldLayout.FieldWrapper, {
    fieldName: fieldName,
    cashbotName: cashbotName
  }, _react.default.createElement(_FieldLabel.FieldLabel, labelProps), _react.default.createElement(_FieldLayout.FieldDivWrapper, null, _react.default.createElement(_FieldSelect.FieldSelect, selectProps, defaultOptions), _react.default.createElement(_FieldIconsDisplay.FieldSelectArrowIcon, selectArrowProps)), _react.default.createElement(_FieldValidationMessage.FieldValidationMessage, validationMsgProps));
};

exports.SelectGroup = SelectGroup;
SelectGroup.defaultProps = {
  value: '',
  atts: {},
  doFocus: false,
  isRequiredField: true,
  showUntouchedErrors: false,
  transparent: false,
  isCentered: false,
  hiddenLabel: false,
  hideValidationIcon: false,
  isInvalid: false,
  isTouched: false,
  warningMessage: null,
  errorMessage: null
};
SelectGroup.propTypes = {
  fieldName: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  atts: _propTypes.default.object,
  cashbotName: _propTypes.default.string.isRequired,
  doFocus: _propTypes.default.bool,
  isRequiredField: _propTypes.default.bool,
  label: _propTypes.default.string.isRequired,
  options: _fieldUtils.optionsPropTypes.isRequired,
  showUntouchedErrors: _propTypes.default.bool,
  transparent: _propTypes.default.bool,
  isCentered: _propTypes.default.bool,
  hiddenLabel: _propTypes.default.bool,
  hideValidationIcon: _propTypes.default.bool,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  warningMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])
};